import React from 'react';

const Publications = () => {
  const publications = [
    { title: 'Leveraging Digital Platforms for Public Health: Customizing SORMAS for Dengue Fever Surveillance in Kenya', year: 'Forthcoming', link: '#', authors: 'Dr. Ferdinard Adungo, Benard Oluoch, et al.' },
    { title: 'Seroprevalence of Arboviruses in Kenyan Children', year: 2023, link: 'https://www.researchgate.net/profile/Ferdinard-Adungo', authors: 'Dr. Ferdinard Adungo et al.' },
    { title: 'Seroprevalence and Distribution of Arboviral Infections in Rural Kenya', year: 2011, link: 'https://pmc.ncbi.nlm.nih.gov/articles/PMC3161961/', authors: 'Dr. Ferdinard Adungo et al.' },
    { title: 'Non-Household Environments in Dengue Transmission', year: 2025, link: 'https://pmc.ncbi.nlm.nih.gov/articles/PMC12000688/', authors: 'Dr. Ferdinard Adungo et al.' },
    { title: 'Mapping Global Variation in Dengue Transmission Intensity', year: 2020, link: 'https://www.science.org/doi/10.1126/scitranslmed.aax4144', authors: 'Dr. Ferdinard Adungo et al.' },
    { title: 'Tsetse Distribution and Trypanosome Infection Rates in Busia County', year: 2020, link: 'https://ouci.dntb.gov.ua/en/works/4K01XRpl/', authors: 'Dr. Ferdinard Adungo et al.' },
  ];

  return (
    <section id="publications" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-bold text-center mb-16 text-blue-800">Our Publications, Manuscripts, and Abstracts</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {publications.map((pub, index) => (
            <div key={index} className="p-6 bg-gray-50 rounded-xl shadow-md hover:shadow-lg transition-all">
              <a href={pub.link} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline font-semibold">
                {pub.title} ({pub.year})
              </a>
              <p className="text-gray-600">{pub.authors}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Publications;